export default "__VITE_ASSET__BuiqTeRF__"